import React from 'react'
import { Loading } from './styles'

const InPageLoading = props => <Loading />

export default InPageLoading
